import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.limit = parseInt(this.getData('limit')) || 6;
        this.items = this.el.querySelectorAll('[data-show-more-item]');
        this.button = this.el.querySelector('[data-show-more-button]');

        if (this.items.length <= this.limit) {
            // Hide button if not enough items
            if (this.button) {
                this.button.style.display = 'none';
            }
            return;
        }

        // Hide items after limit
        this.items.forEach((item, index) => {
            if (index >= this.limit) {
                item.style.display = 'none';
            }
        });

        // Add click event to button
        if (this.button) {
            this.button.addEventListener('click', this.showAll.bind(this));
        }
    }

    showAll() {
        // Show all hidden items
        this.items.forEach((item) => {
            item.style.display = '';
        });

        // Hide the button
        if (this.button) {
            this.button.style.display = 'none';
        }
    }
}

